module.exports = __webpack_public_path__ + "img/icon-time.004c3d64.svg";